import { defineMessages } from '@cookbook/solid-intl'

// Split out of `savings-page.messages.en.js` so the router's document-title/meta-
// description wiring doesn't have to eagerly pull that entire page's messages file
// into the boot-critical chunk just for these strings. Same pattern/rationale as
// `tos-page-routing.messages.en.js` / `privacy-page-routing.messages.en.js`
// (TENANT-5036 bundle audit).
export const messages = {
    descriptionMessage: defineMessages({
        defaultMessage: 'Learn about savings on Lodgr. Estimate how much you can save on short term rentals. Compare fees and see how much more you keep.',
        id: 'SavingsPage.descriptionMessage',
    }),
    titleMessage: defineMessages({
        defaultMessage: 'Savings Calculator | Lodgr',
        id: 'SavingsPage.titleMessage',
    }),
}
